module.exports = __webpack_public_path__ + "img/thermometer-02.3d268912.svg";